module.exports = /[-\s]+(.)?/g